export const columnHeaderDefinitions = {
  parse: (definition) => {
    return `<p class="margin-bottom-5 no-break"><span class="inline-header-cursive">${definition.title}:</span> ${definition.body}</p>`;
  },
  title: '<h2 class="sub-heading-underline">Column Heading Definitions</h2>',
  AGE_END_YEAR: {
    title: 'Age End Year',
    body: 'The age of the insured at the end of the policy year.',
  },
  ANNUAL_DIV_END_YEAR: {
    title: 'Annual Dividend End Year',
    body: 'The total amount of annual dividend payable. These values are based on the illustrated dividend schedule and are not guaranteed.',
  },
  CASH_VAL_END_YEAR: {
    title: 'Cash Value of Additions End Year',
    body: 'The total cash value as of the end of the policy year of the Paid-Up Additions purchased by dividends earned on the base policy. These values are based on the illustrated dividend schedule and are not guaranteed.',
  },
  CONTRACT_PREMIUM: {
    title: 'Contract Premium',
    body: 'The gross premium that is required to be paid at the beginning of the policy year for the benefits shown in this illustration.',
  },
  GUARANTEED_CASH_VAL_END_YEAR: {
    title: 'Guaranteed Cash Value End Year',
    body: 'The cash value which is guaranteed under this policy based upon the illustrated Contract Premium for Guaranteed Values as of the end of the policy year.',
  },
  GUARANTEED_DEATH_BENEFIT_END_YEAR: {
    title: 'Guaranteed Death Benefit End Year',
    body: 'The amount of death benefit which is guaranteed to be payable for this policy at death based upon the illustrated Contract Premium for Guaranteed Values as of the end of the policy year.',
  },
  PAIDUP_ADDITIONS_END_YEAR: {
    title: 'Paid-Up Additions End Year',
    body: 'The additional paid-up insurance death benefit as of the end of the policy year purchased by dividends earned on the base policy{{CirAddPaidupAdditionsEndYear}}. These values are based on the illustrated dividend schedule and are not guaranteed.',
  },
  TOTAL_CASH_VALUE_END_YEAR: {
    title: 'Total Cash Value End Year',
    body: 'The total cash value as of the end of the policy year including all guaranteed and non-guaranteed values. These values are based on the illustrated dividend schedule and are not guaranteed{{CirAddTotalCashValueEndYear}}.',
  },
  TOTAL_DEATH_BENEFIT_END_YEAR: {
    title: 'Total Death Benefit End Year',
    body: 'This is the amount that would be payable if death occurred at the end of the policy year. These values are based on the illustrated dividend schedule and are not guaranteed{{CirAddTotalDeathBenefitEndYear}}.',
  },
  TOTAL_PAIDUP_INS_END_YEAR: {
    title: 'Total Paid-Up Insurance End Year',
    body: 'The amount of fully paid-up insurance that could be purchased if the policy were converted to a fully paid-up policy as of the end of the policy year. These values are based on the illustrated dividend schedule and are not guaranteed.',
  },
  YEAR: {
    title: 'Year',
    body: 'The number of years the policy is assumed to have been in force at the end of the policy year.',
  },
  ANNUAL_NET_BEG_YEAR: {
    title: 'Annual Net Outlay Beg Year',
    body: 'This is the out-of-pocket cost, which is comprised of the Contract Premium and adjusted for any dividends, Paid-Up Additions, cash value released, loans taken, loan repayments made or taxes due at the beginning of the policy year.',
  },
  DIVIDEND_PAID_CASH_BEG_YAER: {
    title: 'Dividend Paid in Cash Beg Year',
    body: 'The annual dividend which is illustrated as being paid in cash.',
  },
  TAX_ON_DIST_BEG_YEAR: {
    title: 'Tax on Distribution Beg Year',
    body: 'This column includes tax on cash distributions, generally surrenders and dividends paid in cash that are in excess of cost basis, tax on interest earned on dividends left to accumulate at interest and/or any tax due because of a Modified Endowment Contract (MEC) status.',
  },
  NET_PREMIUM_BEG_YEAR: {
    title: 'Net Premium Beg Year',
    body: 'The Contract Premium minus any non-guaranteed dividends used to reduce the policy premium.',
  },
  CASH_VALUE_ACCUMS_END_YEAR: {
    title: 'Cash Value of Accums End Year',
    body: 'The total cash value of dividends left to accumulate at interest based on the illustrated, non-guaranteed dividend schedule.',
  },
  ANNUAL_LOAN: {
    title: 'Annual Loan',
    body: 'The amount of loan taken minus loan repayments for the policy year. This includes any amount of unpaid interest.',
  },
  ANNUAL_NET_OUTLAY: {
    title: 'Annual Net Outlay',
    body: 'This is the out-of-pocket cost, which is the Contract Premium adjusted for any dividends paid in cash, dividends used to reduce the premium, partial surrenders, decreases in face amount, loans taken, loan repayments or taxes due for the policy year.',
  },
  ANNUAL_OUTLAY: {
    title: 'Annual Outlay',
    body: 'This is the out-of-pocket cost, which is the Contract Premium adjusted for any dividends paid in cash, dividends used to reduce the premium, partial surrenders, decreases in face amount, loans taken and loan repayments for the policy year, with no adjustments for taxes due.',
  },
  ANNUAL_SURRENDER: {
    title: 'Annual Surrender',
    body: 'The amount of dividends used and/or paid-up additions surrendered. These values are based on the illustrated dividend schedule and are not guaranteed.',
  },
  BASIC_POLICY_CASH_VALUE_END_YEAR: {
    title: 'Basic Policy Cash Value End Year',
    body: 'The guaranteed cash value of the base policy as of the end of the policy year. This does not include the cash value from paid-up additions (PUAs) or any other policy riders.',
  },
  NET_CASH_VALUE_END_YEAR: {
    title: 'Net Cash Value End Year',
    body: 'The cash value as of the end of the policy year reduced by outstanding loans and loan interest. These values are based on the illustrated dividend schedule and are not guaranteed.',
  },
  NET_DEATH_BENEFIT_END_YEAR: {
    title: 'Net Death Benefit End Year',
    body: 'The death benefit of the policy as of the end of the policy year reduced by outstanding loans and loan interest. These values are based on the illustrated dividend schedule and are not guaranteed.',
  },
  TOTAL_CASH_VALUE_OF_ADDITIONS_END_YEAR: {
    title: 'Total Cash Value of Additions End Year',
    body: 'The total cash value as of the end of the policy year of the paid-up additions purchased by dividends. These values are based on the illustrated dividend schedule and are not guaranteed.',
  },
  TOTAL_OUTSTANDING_LOAN_END_YEAR: {
    title: 'Total Outstanding Loan End Year',
    body: 'The loan principal as of the end of the policy year including any prior year capitalized loan interest.',
  },
  TOTAL_PAID_UP_ADDITIONS_END_YEAR: {
    title: 'Total Paid-Up Additions End Year',
    body: 'The death benefit at the end of the policy year of additional paid-up insurance purchased with dividends. These values are based on the illustrated dividend schedule and are not guaranteed.',
  },
  CIR_BENEFIT_MONTHS_REMAINING_END_YEAR: {
    title: 'CIR Benefit Months Remaining End Year',
    body: 'The number of remaining monthly CIR benefit payments as of the end of the year. This assumes that no further paid-up additions are added to the CIR PUA Benefit Pool and no paid-up additions are surrendered after the accelerated benefits start at the beginning of that year. This will automatically be extended if the CIR Benefit Payment is capped at an applicable IRS per diem limit.',
  },
  CIR_BENEFIT_PAYMENT: {
    title: 'CIR Benefit Payment',
    body: "The amount of the policy's death benefit that has been accelerated for the year under the CIR. This assumes an annualized amount of CIR payments for the illustrated claim, limited by the remaining CIR Benefit Pool. Such payment will be capped at the applicable IRS per diem limit, subject to the Internal Revenue Code Sections 7702B and 101(g).",
  },
  CIR_BENEFIT_POOL_END_YEAR: {
    title: 'CIR Benefit Pool End Year',
    body: 'The amount that remains available for CIR benefits as of the end of the policy year.',
  },
  CIR_PREMIUM: {
    title: 'CIR Premium',
    body: 'The premium paid each policy year to purchase the CIR. This amount includes the waiver of premium charge for the CIR, if applicable, and assumes payments are made when due at the beginning of each modal period.',
  },
  CIR_NET_CASH_VALUE_END_YEAR: {
    title: 'Net Cash Value End Year',
    body: 'The cash value as of the end of the policy year less the proportionate reduction once any Chronic Illness benefits have been paid to the policyowner and reduced by outstanding loans and loan interest. These values are based on the illustrated dividend schedule and are not guaranteed. This is the amount payable if the policy was surrendered at the end of the policy year.',
  },
  CIR_NET_DEATH_BENEFIT_END_YEAR: {
    title: 'Net Death Benefit End Year',
    body: 'The death benefit of the policy as of the end of the policy year reduced by the CIR death benefit lien once any Chronic Illness benefits have been paid to the policy owner, outstanding loans and loan interest. These values are based on the illustrated dividend schedule and are not guaranteed.',
  },
  POLICY_PREMIUM: {
    title: 'Policy Premium',
    body: 'The gross premium that is required to be paid at the beginning of the policy year for the benefits shown in this illustration less the CIR Premium.',
  },
  TOTAL_OUTSTANDING_POLICY_DEBT_END_YEAR: {
    title: 'Total Outstanding Policy Debt End Year',
    body: 'The total outstanding loans and accrued interest as of the end of the policy year. This value reflects any applicable reductions that would result from accelerated CIR benefit payments.',
  },
  CIR_ADD_PAIDUP_ADDITIONS_END_YEAR: `. If paid-up additions were made available for acceleration under CIR, this includes a reduction by the PUA Acceleration Charge`,
  CIR_ADD_TOTAL_CASH_VALUE_END_YEAR: `. This value does not reflect a reduction that would result if an accelerated benefit payment was made under the CIR`,
  CIR_ADD_TOTAL_DEATH_BENEFIT_END_YEAR: `. This value does not reflect a reduction due to the CIR death benefit lien that would result if an accelerated benefit payment was made under the CIR`,
};
